var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalletTruckGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_311_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9276 6.78759C30.8379 3.69785 26.7282 2 22.3606 2C17.987 2 13.8833 3.69785 10.7936 6.78759C7.70385 9.87732 6 13.987 6 18.3546C6 27.1918 14.3573 34.5472 18.8509 38.4948C19.4748 39.0468 20.0088 39.5208 20.4408 39.9167C20.9807 40.4207 21.6706 40.6727 22.3606 40.6727C23.0505 40.6727 23.7405 40.4207 24.2744 39.9167C24.7064 39.5208 25.2463 39.0468 25.8703 38.4948C30.3579 34.5472 38.7152 27.1918 38.7152 18.3546C38.7152 13.987 37.0173 9.87732 33.9276 6.78759Z",
    fill: "#3D8B30",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2743 16.8735L22.7039 14.8137L21.7427 15.3631L25.2672 17.4228L26.2743 16.8735Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8101 17.6973L21.2855 15.6833L20.3242 16.1869L23.8488 18.2467L24.8101 17.6973Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0844 18.155C25.0386 18.2008 24.0774 18.7044 24.1232 18.7044V19.9402L25.0844 19.3909V18.155Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4299 19.1164L23.3912 18.5212L19.8208 16.4614L18.8594 17.0565L22.4299 19.1164Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5419 19.5283C25.5419 19.6198 25.4961 19.7114 25.4046 19.7573L23.9856 20.5812C23.9398 20.5812 23.8941 20.627 23.8483 20.627C23.711 20.627 23.6194 20.5355 23.6194 20.3981V18.9791L22.6123 19.5284V23.6024C22.6581 23.5566 26.6404 21.2678 26.4573 21.4051V17.3312L25.5419 17.8347L25.5419 19.5283Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5669 24.1973C22.4755 24.2431 22.3838 24.2431 22.338 24.1973L18.3099 21.8627C18.2184 21.8169 18.1726 21.7254 18.1726 21.6796V18.3838C18.1267 18.4296 14.0986 20.764 14.1444 20.7183L23.574 26.1655L30.3029 22.2747L27.0071 20.3522V21.5424C27.0071 21.6339 26.9613 21.7255 26.8698 21.7713C21.2395 24.9295 22.9788 23.9225 22.567 24.1972L22.5669 24.1973Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6304 21.4966L22.2008 23.5563V19.4824L18.6304 17.4226V21.4966Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.669 24.0142C30.6232 24.06 29.7993 24.5177 29.8451 24.4719C29.9824 24.7465 30.074 25.1585 30.0282 25.4331L30.5776 25.1127C30.7607 25.0212 30.7607 24.7465 30.7607 24.6092C30.7607 24.4261 30.7149 24.243 30.669 24.0142Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6653 28.0425C23.4821 28.1339 23.3448 27.951 22.8413 27.722C23.2532 28.2714 23.3906 28.8664 23.3906 29.3241L23.94 29.0037C24.0773 28.9122 24.1231 28.7291 24.1231 28.5002C24.1231 28.3171 24.0773 28.0883 23.9858 27.8593L23.6653 28.0425Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9258 27.4931C21.4681 27.2185 21.1934 27.4017 21.1934 27.905C21.1934 28.5001 21.6511 29.2784 22.1546 29.5987C22.5209 29.7819 22.7955 29.7819 22.8871 29.3698C22.9786 28.7748 22.5209 27.8592 21.9258 27.4931Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.433 24.7466L28.3345 25.3416C28.4718 25.5247 28.6549 25.662 28.7922 25.7535C29.1584 25.9824 29.4788 25.8908 29.5247 25.4789C29.5703 25.2501 29.4788 24.9297 29.433 24.7466Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5317 23.5565V22.6867L23.6655 26.6233C23.574 26.6692 23.4824 26.6692 23.4365 26.6233L13.8696 21.0846V21.9544C25.2675 28.5917 12.0386 20.9015 23.5281 27.5389C23.8485 27.4014 30.6689 23.4191 30.5316 23.5564L30.5317 23.5565Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1971 24.5635L15.7465 24.2431C15.8838 24.1516 15.9296 23.9685 15.9296 23.7396L14.6479 23.0071C14.9682 23.3735 15.243 24.0143 15.1971 24.5635Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5917 7.76416H19.5459C19.5001 7.76416 19.4086 7.80998 19.3628 7.80998L14.6022 10.5564C14.3733 10.6937 14.1445 11.0141 14.0987 11.2889C14.053 11.472 14.053 11.6093 14.0988 11.655L16.2961 14.5387C16.3876 14.676 16.4334 14.8133 16.4334 14.9964V18.75C16.5249 18.7041 17.3032 18.2464 17.2573 18.2464V14.2183C17.2573 14.0352 17.3032 13.8521 17.3488 13.7148L19.5917 8.31338C19.6832 8.03878 19.6376 7.80985 19.5917 7.76404L19.5917 7.76416ZM16.7994 12.9367C16.7994 12.9825 16.7536 12.9825 16.7536 13.0282L16.5247 13.1655L15.1972 11.4261C15.1972 11.3803 15.243 11.1971 15.3345 11.1515L18.2184 9.45778L16.7994 12.9367Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7325 22.7325C13.2748 22.4579 13 22.641 13 23.1444C13 23.7394 13.4577 24.5177 13.9613 24.8381C14.3275 25.0671 14.6479 24.9754 14.6937 24.5635C14.7852 23.9225 14.2817 23.0529 13.7325 22.7325Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_311_219",
    x: 0.5,
    y: 0.5,
    width: 43.7153,
    height: 49.6726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_311_219"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_311_219",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalletTruckGreenIcon);
export default __webpack_public_path__ + "static/media/PalletTruckGreenIcon.05a9d48dacfe6de34faa8725db373185.svg";
export { ForwardRef as ReactComponent };